import React from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';

import usePopup from 'hooks/usePopup';
import Button from 'kingpin/atoms/Button';
import EditPinnedAssetsPopup from './EditPinnedAssetsPopup';

const EditPinnedAssetsButton = ({
  section,
  app,
}: {
  section: V3.Navigation.SideSection;
  app: V3.App;
}) => {
  const { isOpen, open, close } = usePopup();

  if (!section.sectionSettings || !section.sectionSettings.isPinnedSection) {
    return null;
  }

  return (
    <>
      <Button
        size={'X-Small'}
        type={'Ghost'}
        icon={'edit-outline'}
        iconColor={'var(--color-text-muted)'}
        onClick={isOpen ? close : open}
      />
      <ModalTransition>
        {isOpen && (
          <EditPinnedAssetsPopup app={app} section={section} close={close} />
        )}
      </ModalTransition>
    </>
  );
};
export default EditPinnedAssetsButton;
